import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, createSlots as _createSlots, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "m-auto px-8 md:px-20" }
const _hoisted_2 = { class: "max-w-screen-2xl m-auto" }
const _hoisted_3 = { class: "flex justify-between items-center text-xl py-10" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "rotate-x-180 overflow-x-scroll" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "rotate-x-180 overflow-x-scroll" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Switcher = _resolveComponent("Switcher")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_NextTable = _resolveComponent("NextTable")!
  const _component_InfiniteLoading = _resolveComponent("InfiniteLoading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_component_Loading, { visible: _ctx.loading }, null, 8, ["visible"])
    ])),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Switcher, {
            modelValue: _ctx.tab_show,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab_show) = $event)),
            options: ['I miei budget', 'Tutti i budget']
          }, null, 8, ["modelValue"]),
          _createVNode(_component_NextButton, {
            variant: "primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.visible=true)),
            class: "ml-3 py-2 px-4 m-0 hidden sm:flex items-center"
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode(" + Aggiungi ")
            ])),
            _: 1
          })
        ]),
        (!_ctx.tab_show)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_NextTable, {
                  class: "rotate-x-180 w-full border-separate border-spacing-3 py-4 py-5 table-fixed",
                  cols: _ctx.budgetCols,
                  "onUpdate:cols": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.budgetCols) = $event)),
                  rows: _ctx.listaMyBudget.rows,
                  onOrderUpdate: _ctx.listaMyBudget.updateCols
                }, _createSlots({ _: 2 }, [
                  _renderList(_ctx.listaMyBudget.rows, (c, j) => {
                    return {
                      name: `td_${j}_2`,
                      fn: _withCtx((context) => [
                        _createTextVNode(_toDisplayString(_ctx.$filters.toDate(context.context.row.data_inizio)), 1)
                      ])
                    }
                  }),
                  _renderList(_ctx.listaMyBudget.rows, (c, j) => {
                    return {
                      name: `td_${j}_3`,
                      fn: _withCtx((context) => [
                        _createTextVNode(_toDisplayString(_ctx.$filters.toDate(context.context.row.data_inizio)), 1)
                      ])
                    }
                  }),
                  _renderList(_ctx.listaMyBudget.rows, (c, j) => {
                    return {
                      name: `td_${j}_4`,
                      fn: _withCtx((context) => [
                        _createTextVNode(_toDisplayString(_ctx.budgetPreventivo(context.context.row.budget)), 1)
                      ])
                    }
                  })
                ]), 1032, ["cols", "rows", "onOrderUpdate"])
              ]),
              _createVNode(_component_InfiniteLoading, {
                onInfinite: _ctx.listaMyBudget.fetchNextPage,
                identifier: _ctx.listaMyBudget.infiniteIdentifier,
                style: {"min-height":"1px"}
              }, {
                complete: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createElementVNode("div", { class: "text-center pb-3" }, "Non ci sono altri clienti.", -1)
                ])),
                _: 1
              }, 8, ["onInfinite", "identifier"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_NextTable, {
                  class: "rotate-x-180 w-full border-separate border-spacing-3 py-4 py-5 table-fixed",
                  cols: _ctx.budgetCols,
                  "onUpdate:cols": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.budgetCols) = $event)),
                  rows: _ctx.listaBudget.row,
                  onOrderUpdate: _ctx.listaBudget.updateCols
                }, _createSlots({ _: 2 }, [
                  _renderList(_ctx.listaBudget.row, (c, j) => {
                    return {
                      name: `td_${j}_2`,
                      fn: _withCtx((context) => [
                        _createTextVNode(_toDisplayString(_ctx.$filters.toDate(context.context.row.data_inizio)), 1)
                      ])
                    }
                  }),
                  _renderList(_ctx.listaBudget.row, (c, j) => {
                    return {
                      name: `td_${j}_3`,
                      fn: _withCtx((context) => [
                        _createTextVNode(_toDisplayString(_ctx.$filters.toDate(context.context.row.data_inizio)), 1)
                      ])
                    }
                  }),
                  _renderList(_ctx.listaBudget.row, (c, j) => {
                    return {
                      name: `td_${j}_4`,
                      fn: _withCtx((context) => [
                        _createTextVNode(_toDisplayString(_ctx.budgetPreventivo(context.context.row.budget)), 1)
                      ])
                    }
                  })
                ]), 1032, ["cols", "rows", "onOrderUpdate"])
              ]),
              _createVNode(_component_InfiniteLoading, {
                onInfinite: _ctx.listaBudget.fetchNextPage,
                identifier: _ctx.listaBudget.infiniteIdentifier,
                style: {"min-height":"1px"}
              }, {
                complete: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createElementVNode("div", { class: "text-center pb-3" }, "Non ci sono altri clienti.", -1)
                ])),
                _: 1
              }, 8, ["onInfinite", "identifier"])
            ]))
      ])
    ])
  ], 64))
}